export class StoreRecentActivity {
    static readonly type = '[Navigation] StoreRecentActivity';
    constructor(public readonly url: string, public readonly title?: string) { }
}

export class ClearCurrentPage {
    static readonly type = '[Navigation] ClearCurrentPage'
}
